import { toggleSidebar, useTranslate } from "ra-core";
import * as React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import MenuIcon from "@material-ui/icons/Menu";
import { IconButton, makeStyles } from "@material-ui/core";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginLeft: "0.2em",
    marginRight: "0.2em",
  },
  menuButtonIconClosed: {
    transition: theme.transitions.create(["transform"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    transform: "rotate(0deg)",
  },
  menuButtonIconOpen: {
    transition: theme.transitions.create(["transform"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    transform: "rotate(180deg)",
  },
}));

const CustomSidebarToggleButton = (props: any) => {
  const { open } = props;
  const translate = useTranslate();
  const dispatch = useDispatch();
  const classes = useStyles(props);

  return (
    <Tooltip
      title={translate(open ? "ra.action.close_menu" : "ra.action.open_menu", {
        _: "Open/Close menu",
      })}
      enterDelay={500}
    >
      <IconButton
        color="inherit"
        onClick={() => dispatch(toggleSidebar())}
        className={classes.menuButton}
      >
        <MenuIcon
          classes={{
            root: open
              ? classes.menuButtonIconOpen
              : classes.menuButtonIconClosed,
          }}
        />
      </IconButton>
    </Tooltip>
  );
};

export default CustomSidebarToggleButton;
